import ThemeRoutes from "../routes/Router";

export const getActivePage = (history) => {
  const pathname = history.location.pathname;

  let route = ThemeRoutes.find((r) => r.path === pathname);

  if (route) {
    return {
      title: route.name,
      icon: route.icon,
    };
  }

  route = ThemeRoutes.find((r) =>
    r.child?.find((child) => child.path === pathname)
  );
  if (route) {
    return {
      title: route.child.find((child) => child.path === pathname).name,
      icon: route.icon,
    };
  }
  return {
    title: "",
    icon: "",
  };
};
